// extracted by mini-css-extract-plugin
module.exports = {"content":"WelcomeMessageContent_content__2Jc0f","textTitles":"WelcomeMessageContent_textTitles__QI8X0","imageContent":"WelcomeMessageContent_imageContent__nlOGu"};